var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgerMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 19.167,
    viewBox: "0 0 23 19.167",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 20
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 20,
    transform: "translate(0 8.084)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x2: 19.977,
    transform: "translate(0 16.167)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenuIcon);
export default __webpack_public_path__ + "static/media/burger-menu-icon.84985e8ca5f235fc6447dcd43306cea1.svg";
export { ForwardRef as ReactComponent };